import {
  getAmotConstructionListCount,
  getAmotConstructionLobby,
  getAmotConstructionLobbyV3,
} from "api"
import { getSiteIdByLocale } from "api/SiteId"
import LobbyPage from "components/lobbypage/LobbyPage"
import { NextSeo } from "next-seo"

export const getStaticProps = async ({ locale }) => {
  const siteId = getSiteIdByLocale(locale)
  const { data: searchMetadata } = await getAmotConstructionLobbyV3(siteId)

  const response = await getAmotConstructionLobby(siteId)
  const data = {
    ...response?.data,
    pages: [],
  }

  const assetsList = await getAmotConstructionListCount("-1", siteId)
  return {
    props: {
      messages: (await import(`../../../messages/${locale}.json`)).default,
      data,
      assets: assetsList?.data || [],
      searchMetadata,
    },
    revalidate: 60,
  }
}

const Construction = ({ data, assets, searchMetadata }) => {
  return (
    <>
      <NextSeo
        title={data?.metaTitle}
        description={data?.metaDescription}
        additionalMetaTags={[{ name: "keywords", content: data.metaKeywords }]}
        openGraph={{
          title: data?.ogTitle || data?.metaTitle,
          description: data?.ogDescription || data?.metaDescription,
          images: [{ url: data?.ogImage?.media?.publicUrl || "" }],
        }}
      />
      <LobbyPage
        data={data}
        assets={assets}
        searchMetadata={searchMetadata}
        hideSearch={true}
        pageType="construction"
      />
    </>
  )
}

export default Construction
